import script from "./SecureAndProtectContentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SecureAndProtectContentModal.vue?vue&type=script&lang=ts&setup=true"

import "./SecureAndProtectContentModal.vue?vue&type=style&index=0&id=a49a823a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a49a823a"]])

export default __exports__